import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import React from "react";

const challengeSchema = z.object({
  tab: z.string(),
  source: z.string().optional(),
});

export const Route = createFileRoute("/community-challenge")({
  component: React.lazy(() =>
    import("@/pages/community-challenge").then((mod) => ({
      default: mod.CommunityChallenge,
    })),
  ),
  validateSearch: (search) => challengeSchema.parse(search),
});
